
import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";

@Component
export default class NotFound extends Vue {
  @Getter("fontColor")
  private fontColor!: string;
}
